module.exports = __webpack_public_path__ + "assets/img/paying.f674fd78.png";